var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable sonarjs/cognitive-complexity */
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import Lottie from 'lottie-web';
import { mapToCssModules } from '../../utils/className';
import { SmlsModal } from '../Modal';
import TestIn from './data/in';
import TestInOut from './data/in_out';
import TestSpin from './data/spin';
export const SmlsAnimation = (_a) => {
    var { id, containerIdLottie = '', typeModal = 'full', finishMode = 'yes', currentState, message, className = '', stopEndDuration = 3000, onExit } = _a, props = __rest(_a, ["id", "containerIdLottie", "typeModal", "finishMode", "currentState", "message", "className", "stopEndDuration", "onExit"]);
    const [spin, setSpin] = useState({});
    const [isOpen, setIsOpen] = useState(false);
    const [loadAnimation, setLoadAnimation] = useState(false);
    const classContainer = useMemo(() => `.key-animation-${containerIdLottie}`, [
        containerIdLottie,
    ]);
    useEffect(() => {
        if (currentState.isLoading)
            setIsOpen(true);
    }, [currentState]);
    const onOpened = useCallback(() => {
        setLoadAnimation(true);
    }, []);
    const onFinish = useCallback(() => {
        setIsOpen(false);
        setSpin({});
        setLoadAnimation(false);
    }, []);
    const startEndStep = useCallback(() => {
        const endAnimation = Lottie.loadAnimation({
            container: document.querySelector(classContainer),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: TestInOut,
        });
        endAnimation.addEventListener('loopComplete', () => {
            onFinish();
            endAnimation.destroy();
        });
    }, [loadAnimation]);
    useEffect(() => {
        if (currentState.isLoading && loadAnimation) {
            const animationIn = Lottie.loadAnimation({
                container: document.querySelector(classContainer),
                renderer: 'svg',
                loop: true,
                autoplay: true,
                animationData: TestIn,
            });
            animationIn.addEventListener('loopComplete', () => {
                animationIn.destroy();
                setSpin(Lottie.loadAnimation({
                    container: document.querySelector(classContainer),
                    renderer: 'svg',
                    loop: true,
                    autoplay: true,
                    animationData: TestSpin,
                }));
            });
        }
    }, [loadAnimation]);
    useEffect(() => {
        if (Object.keys(spin).length)
            if (finishMode === 'wait' || finishMode === 'yes') {
                spin.addEventListener('loopComplete', () => {
                    if (!currentState.isLoading && finishMode === 'yes') {
                        spin.destroy();
                        startEndStep();
                    }
                    if (!currentState.isLoading && finishMode === 'wait') {
                        spin.pause();
                        setTimeout(() => {
                            spin.destroy();
                            startEndStep();
                        }, stopEndDuration);
                    }
                });
            }
            else if (finishMode === 'no' && !currentState.isLoading) {
                spin.destroy();
                onFinish();
            }
    }, [spin, currentState.isLoading]);
    return (React.createElement(SmlsModal, Object.assign({ id: id, isOpen: isOpen, type: typeModal, onExit: onExit, defaultHeader: false, onOpened: onOpened, className: mapToCssModules([className, 'smls-animation']) }, props),
        React.createElement("div", { id: id, className: mapToCssModules([
                'smls-animation-lottie',
                `key-animation-${containerIdLottie}`,
                !currentState.isLoading && !currentState.isSuccess ? 'inverse' : '',
            ]) }),
        React.createElement("div", { className: "text start" },
            currentState.isLoading &&
                (message === null || message === void 0 ? void 0 : message.loading.map((msg) => (React.createElement("span", { className: "start", key: msg }, msg)))),
            currentState.isSuccess &&
                !currentState.isLoading &&
                (message === null || message === void 0 ? void 0 : message.success.map((msg) => (React.createElement("span", { className: "start", key: msg }, msg)))),
            !currentState.isSuccess &&
                !currentState.isLoading &&
                (message === null || message === void 0 ? void 0 : message.error.map((msg) => (React.createElement("span", { className: "finish", key: msg }, msg)))))));
};
//# sourceMappingURL=index.js.map